import { useEffect, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import {  Grid, Box, Button, Typography, Dialog, 
          DialogTitle, DialogContent, Alert, DialogActions, 
          IconButton, Checkbox, FormControlLabel, Divider, Snackbar , Tooltip , Tabs, Tab , CssBaseline, Menu, MenuItem , styled, alpha } from "@mui/material";
import { Cancel as CancelIcon, ZoomIn as ZoomInIcon, ZoomOut as ZoomOutIcon, Undo as UndoIcon, Redo as RedoIcon, 
    DeleteOutlineOutlined as DeleteOutlineOutlinedIcon,  CenterFocusWeak as CenterFocusWeakIcon, ThreeSixty as ThreeSixtyIcon,
    ContentCopy as ContentCopyIcon, ContentPaste as ContentPasteIcon, ContentCut as ContentCutIcon, SwapHoriz as SwapHorizIcon, SwapVert as SwapVertIcon ,
    KeyboardArrowDown as KeyboardArrowDownIcon 
} from '@mui/icons-material';
import HeaderBar from "../Header/HeaderBar";
import "./Diagram.css";
import { Brightness4, Brightness7 } from '@mui/icons-material';
import nmos4Shape from "../../js/nmos4Shape";
import nmosShape from "../../js/nmosShape";
import pmos4Shape from "../../js/pmos4Shape";
import pmosShape from "../../js/pmosShape";
import vddShape from "../../js/vddShape";
import vssShape from "../../js/vssShape";
import inputPinShape from "../../js/inputPinShape";
import outputPinShape from "../../js/outputPinShape";
import SaveIcon from "@mui/icons-material/Save";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CloseIcon from '@mui/icons-material/Close';

import { useTheme ,ThemeProvider, createTheme } from "@mui/material/styles";
import NewCellDialog from "../Cell/NewCellDialog";
import GraphToolbar from "./GraphToolbar";
import { Common } from "../../utils/common";

import AddInstanceDialog from "../Instance/AddInstanceDialog.";
import AddPinDialog from "../Pin/AddPinDialog";

const mxModule = require("mxgraph")();

const {
  mxCell,
  mxCellEditor,
  mxCellHighlight,
  mxCellRenderer,
  mxClient,
  mxCodec,
  mxConnectionHandler,
  mxConstants,
  mxConstraintHandler,
  mxDivResizer,
  mxDragSource,
  mxEdgeHandler,
  mxEdgeSegmentHandler,
  mxEdgeStyle,
  mxEllipse,
  mxEvent,
  mxGeometry,
  mxGraph,
  mxGraphHandler,
  mxGraphModel,
  mxGraphView,
  mxGuide,
  mxImage,  
  mxPoint,  
  mxRubberband,
  mxStyleRegistry,
  mxToolbar,  
  mxUtils,
  mxResources,
} = mxModule;

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
    ...theme.applyStyles('dark', {
      color: theme.palette.grey[300],
    }),
  },
}));


const Diagram = () => {
  const containerRef = useRef(null);
  const toolbarRef = useRef(null);
  const theme = useTheme();
  const initialized = useRef(false); // Prevent duplicate execution
  const { id } = useParams();
  const [openDialog, setOpenDialog] = useState(false);
  const [gXml, setGXml] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editData, setEditData] = useState(null);
  var [graph, setGraph] = useState(null);
  const [open, setOpen] = useState(true);
  const [openResetDialog, setOpenResetDialog] = useState(false);
  const [isDiagramEmpty, setIsDiagramEmpty] = useState(true);

  //tabs
  const [newCellopen, setNewCellOpen] = useState(false);
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);

  const graphRef = useRef(null);
  const commonRef = useRef(null);
 //themes
  const [mode, setMode] = useState(localStorage.getItem('theme-mode') || 'dark');

  const insertModeRef = useRef(false);
  const insertCellRef = useRef(null);
  const previewRef = useRef(null);
  const instanceCounterRef = useRef(1);
  const instancesMapRef = useRef({});
  const [nextInstanceName, setNextInstanceName] = useState("i1");

  const selectedShapeTypeRef = useRef('');
  const selectedIconPathRef = useRef('');

  const localTheme = createTheme({
    palette: {
      mode,
    },
  });

  const toggleMode = () => {
    setMode((prev) => {
      const newMode = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme-mode', newMode); 
      return newMode;
    });
  };
  const isDarkMode = (mode === 'dark');

  //customized menu
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCreateCell = ({ cellName }) => {
    if (!cellName) return;
    const newTabs = [...tabs, cellName];
    setTabs(newTabs);
    setSelectedTab(newTabs.length - 1);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  //tabs
  const handleBeforeUnload = (e) => {
    if (!isDiagramEmpty) {
      console.log("iss", isDiagramEmpty);
      e.preventDefault();
      e.returnValue = mxResources.get("changesLost");
      return mxResources.get("changesLost");
    }
  };

  useEffect(() => {
    if (!graph) return;
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [handleBeforeUnload]);

  useEffect(() => {
    if (!containerRef.current || initialized.current)
      return;
    // if (initialized.current) return; // Skip if already initialized
    initialized.current = true; // Mark as initialized
    const loadMxGraph = async () => {
      InitializeMeOnce();

      // Creates the model and the graph inside the container
      // using the fastest rendering available on the browser
      var model = new mxGraphModel();
      graph = new mxGraph(containerRef.current, model); // Initialize graph
      graphRef.current = graph;
      setGraph(graph);
      // Initialize Common class here
      commonRef.current = new Common(graph);
      main(model, graph);

      if (id !== undefined) {
        const importOnEdit = () => {
          graph.getModel().beginUpdate();
          try {
            fetch(`${process.env.REACT_APP_API_URL}/schematicDiagram/${id}`)
              .then((res) => res.json())
              .then((data) => {
                const xmlData = data.xmlData.replace(/\\"/g, '"');
                console.log(xmlData.replace(/"/g, '\\"'));
                loadXmlOnGraphForEdit(graph, xmlData);
                setEditData(data);
              });
          } finally {
            graph.getModel().endUpdate();
          }
        };

        setIsEditMode(true);
        importOnEdit();
      } else {
        setIsEditMode(false);
      }
    };

    loadMxGraph();
  }, [tabs, selectedTab]);

  useEffect(() => {
    if (!graph) return;

    const edgeStrokeColor = isDarkMode ? "#38befe" : "#000000";

    const model = graph.getModel();
    const parent = graph.getDefaultParent();

    model.beginUpdate();
    try {
      const allEdges = graph.getChildEdges(parent);

      allEdges.forEach((edge) => {
        let style = model.getStyle(edge) || "";

        // Replace or add strokeColor in style string
        if (style.includes("strokeColor=")) {
          style = style.replace(
            /strokeColor=[^;]*/,
            `strokeColor=${edgeStrokeColor}`
          );
        } else {
          style += `;strokeColor=${edgeStrokeColor}`;
        }

        model.setStyle(edge, style);
      });
    } finally {
      model.endUpdate();
    }
    if (containerRef.current) {
      console.log(
        containerRef.current.clientHeight,
        containerRef.current.scrollHeight
      );
      containerRef.current.style.height = `${containerRef.current.scrollHeight}px`;
    }
    graph.refresh();
  }, [mode]);
  
  
  
  // useEffect(() => {
  //   if (id !== undefined) {
  //     setIsEditMode(true);
  //     importOnEdit();
  //   } else {
  //     setIsEditMode(false);
  //   }
  // }, [id]);

  useEffect(() => {
    if (!graph) return;

    // Graph model change listener
    const modelListener = () => checkIfDiagramIsEmpty();
    graph.getModel().addListener(mxEvent.CHANGE, modelListener);
  
  //   commonRef.current = {
  //   delete: () => {
  //     const selectedCells = graph.getSelectionCells();
  //     Object.keys(instancesMapRef.current).forEach((key) => {
  //     if (selectedCells.includes(instancesMapRef.current[key]?.cell)) {
  //       delete instancesMapRef.current[key];
  //     }
  //   });
  //     graph.removeCells(selectedCells);
  //     console.log("updated instancesMapRef:", instancesMapRef.current);
  //   }
  // };
  commonRef.current?.delete(instancesMapRef);
    const handleMouseMove = (e) => {

      if (insertModeRef.current && previewRef.current && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const isInsideGraph =
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom;

        // const isOverPopup = addInstanceRef.current?.contains(e.target);
        // const dialogContent = document.querySelector('[role="dialog"]');
        const isOverDialog = e.target.closest('.MuiDialog-container, .MuiPopover-root, .MuiModal-root') !== null;
        // const isOverPopup = dialogContent?.contains(e.target);
        // console.log("aaa", isOverPopup ,e.target ,dialogContent)

        if (isInsideGraph && !isOverDialog) {
          const offsetX = e.clientX - rect.left;
          const offsetY = e.clientY - rect.top;

          previewRef.current.style.left = `${offsetX - 30}px`;
          previewRef.current.style.top = `${offsetY - 45}px`;
          previewRef.current.style.display = "block";
        } else {
          previewRef.current.style.display = "none";
        }
      }

    };

    const handleRightClick = (e) => {
      e.preventDefault(); // prevent the default context menu

      insertModeRef.current = false;
      insertCellRef.current = null;

      if (previewRef.current) {
        previewRef.current.remove();
        previewRef.current = null;
      }
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("contextmenu", handleRightClick);
    // Cleanup both listeners
    return () => {
      graph.getModel().removeListener(modelListener);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, [graph]);

  const checkIfDiagramIsEmpty = () => {
    if (graph) {
      const hasVertices =
        graph.getChildVertices(graph.getDefaultParent()).length === 0;
      setIsDiagramEmpty(hasVertices);
    }
  };

  function main(model, graph) {
    // If connect preview is not moved away then getCellAt is used to detect the cell under
    // the mouse if the mouse is over the preview shape in IE (no event transparency), ie.
    // the built-in hit-detection of the HTML document will not be used in this case.
    mxConnectionHandler.prototype.movePreviewAway = false;
    mxConnectionHandler.prototype.waypointsEnabled = true;
    mxGraph.prototype.resetEdgesOnConnect = false;
    mxConstants.SHADOWCOLOR = "#C0C0C0";
    var joinNodeSize = 7;
    var strokeWidth = 1;

    // Replaces the port image
    mxConstraintHandler.prototype.pointImage = new mxImage(
      "/editors/images/point.gif",
      5,
      5
    );

    // Alt disables guides
    mxGuide.prototype.isEnabledForEvent = function (evt) {
      return !mxEvent.isAltDown(evt);
    };

    // Enables snapping waypoints to terminals
    mxEdgeHandler.prototype.snapToTerminals = true;
    graph.dropEnabled = true;
    graph.setConnectable(true);
    graph.setMultigraph(true);

    // MyToolBarCheck(graph, toolbarRef.current);

    graph.view.scale = 1;
    graph.setPanning(true);
    graph.setTooltips(true);
    graph.setConnectable(true);
    graph.setConnectableEdges(true);
    graph.setDisconnectOnMove(false);
    graph.foldingEnabled = false;

    graph.graphHandler.previewEnabled = true;
    graph.graphHandler.guidesEnabled = true; // Optional alignment guides
    graph.graphHandler.highlightDropTargets = true;

    graph.setAllowLoops(true); //to allow the connections of same vertex connection points
    //Maximum size

    //commented to keep the graph height grow when the container height grows.
    // graph.maximumGraphBounds = new mxRectangle(
    //   0,
    //   0,
    //   containerRef.current.clientWidth,
    //   containerRef.current.clientHeight
    // );

    graph.border = 50;

    // Panning handler consumed right click so this must be
    // disabled if right click should stop connection handler.
    graph.panningHandler.isPopupTrigger = function () {
      return false;
    };

    // Enables return key to stop editing (use shift-enter for newlines)
    graph.setEnterStopsCellEditing(true);

    // Adds rubberband selection
    new mxRubberband(graph);

    // Alternative solution for implementing connection points without child cells.
    // This can be extended as shown in portrefs.html example to allow for per-port
    // incoming/outgoing direction.
    graph.getAllConnectionConstraints = function (terminal) {
      if (
        terminal != null &&
        terminal.shape != null &&
        terminal.shape.stencil == null &&
        terminal.shape.constraints != null
      ) {
        return terminal.shape.constraints;
      }
    };

    // Makes sure non-relative cells can only be connected via constraints
    graph.connectionHandler.isConnectableCell = function (cell) {
      if (this.graph.getModel().isEdge(cell)) {
        return true;
      } else {
        var geo = cell != null ? this.graph.getCellGeometry(cell) : null;

        return geo != null ? geo.relative : false;
      }
    };
    mxEdgeHandler.prototype.isConnectableCell = function (cell) {
      return graph.connectionHandler.isConnectableCell(cell);
    };

    graph.connectionHandler.marker.highlightColor = "red"; //phye logo color to be changed

    // Adds a special tooltip for edges

    var getTooltipForCell = graph.getTooltipForCell;
    graph.getTooltipForCell = function (cell) {
      var tip = "";

      if (cell != null) {
        var src = this.getModel().getTerminal(cell, true);

        if (src != null) {
          tip += this.getTooltipForCell(src) + " ";
        }

        var parent = this.getModel().getParent(cell);

        if (this.getModel().isVertex(parent)) {
          tip += this.getTooltipForCell(parent) + ".";
        }

        tip += getTooltipForCell.apply(this, arguments);

        var trg = this.getModel().getTerminal(cell, false);

        if (trg != null) {
          tip += " " + this.getTooltipForCell(trg);
        }
      }

      return tip;
    };

    // Switch for black background and bright styles
    var invert = false;
    if (invert) {
      // container.style.backgroundColor = 'black';

      // White in-place editor text color
      let mxCellEditorStartEditing = mxCellEditor.prototype.startEditing;
      mxCellEditor.prototype.startEditing = function (cell, trigger) {
        mxCellEditorStartEditing.apply(this, arguments);

        if (this.textarea != null) {
          this.textarea.style.color = "#FFFFFF";
        }
      };

      mxGraphHandler.prototype.previewColor = "white";
    }

    var labelBackground = invert ? "#000000" : "#FFFFFF";
    var fontColor = invert ? "#FFFFFF" : "#000000";
    // var strokeColor = invert ? "#C0C0C0" : "#000000";

    var fillColor = invert ? "none" : "#FFFFFF";

    var style = graph.getStylesheet().getDefaultEdgeStyle();
    const edgeStrokeColor = isDarkMode ? "#38befe" : "#000000";
    delete style["endArrow"];
    style["strokeColor"] = edgeStrokeColor;
    style["labelBackgroundColor"] = labelBackground;
    style["edgeStyle"] = "wireEdgeStyle";
    style["fontColor"] = fontColor;
    style["fontSize"] = "9";
    style["movable"] = "0";
    style["strokeWidth"] = strokeWidth;
    style["orthogonalLoop"] = "1"; //to allow the connections of same vertex connection points
    //style['rounded'] = '1';

    // Sets join node size
    style["startSize"] = joinNodeSize;
    style["endSize"] = joinNodeSize;

    style = graph.getStylesheet().getDefaultVertexStyle();
    var vertexStrokeColor = "#00cc66";
    style["gradientDirection"] = "south";
    //style['gradientColor'] = '#909090';
    style["strokeColor"] = vertexStrokeColor;
    //style['fillColor'] = '#e0e0e0';
    style["fillColor"] = "none";
    style["fontColor"] = fontColor;
    style["fontStyle"] = "1";
    style["fontSize"] = "12";
    style["resizable"] = "0";
    style["rounded"] = "1";
    style["strokeWidth"] = strokeWidth;


    graph.addListener(mxEvent.CLICK, function (sender, evt) {
      const mouseEvent = evt.getProperty('event');
      if (mouseEvent.button === 0 && insertModeRef.current && insertCellRef.current) {
        const pt = graph.getPointForEvent(mouseEvent);

        const originalCell = insertCellRef.current;
        const clone = graph.getModel().cloneCell(originalCell);

        // Offset to center shape under cursor
        const width = clone.geometry.width;
        const height = clone.geometry.height;

        clone.geometry.x = pt.x - width / 2;
        clone.geometry.y = pt.y - height / 2;

        const instanceName = `i${instanceCounterRef.current}`;
        clone.value = instanceName;
        //storing to dictionary
        instancesMapRef.current[instanceName] = {
          cell: clone,
          shapeType: originalCell.style,
        };
        graph.getModel().beginUpdate();
        try {
          graph.addCell(clone);
          graph.setSelectionCell(clone);
        } finally {
          graph.getModel().endUpdate();
        }  
        instanceCounterRef.current += 1;
          setNextInstanceName(`i${instanceCounterRef.current}`);
        // console.log("Placing instance:", instanceName);
        // console.log("All instance counts:", instancesMapRef);
        // Cleanup
        // insertModeRef.current = false;
        // insertCellRef.current = null;
        // if (previewRef.current) {
        //   previewRef.current.remove();
        //   previewRef.current = null;
        // }
      }
    });


    mxEvent.disableContextMenu(containerRef.current);
  }

  function InitializeMeOnce() {
    // Computes the position of edge to edge connection points.
    mxGraphView.prototype.updateFixedTerminalPoint = function (
      edge,
      terminal,
      source,
      constraint
    ) {
      var pt = null;
      if (constraint != null) {
        pt = this.graph.getConnectionPoint(terminal, constraint);
      }

      if (source) {
        edge.sourceSegment = null;
      } else {
        edge.targetSegment = null;
      }

      if (pt == null) {
        var s = this.scale;
        var tr = this.translate;
        var orig = edge.origin;
        var geo = this.graph.getCellGeometry(edge.cell);
        pt = geo.getTerminalPoint(source);

        // Computes edge-to-edge connection point
        if (pt != null) {
          pt = new mxPoint(
            s * (tr.x + pt.x + orig.x),
            s * (tr.y + pt.y + orig.y)
          );

          // Finds nearest segment on edge and computes intersection
          if (terminal != null && terminal.absolutePoints != null) {
            var seg = mxUtils.findNearestSegment(terminal, pt.x, pt.y);

            // Finds orientation of the segment
            var p0 = terminal.absolutePoints[seg];
            var pe = terminal.absolutePoints[seg + 1];
            var horizontal = p0.x - pe.x == 0;

            // Stores the segment in the edge state
            var key = source ? "sourceConstraint" : "targetConstraint";
            var value = horizontal ? "horizontal" : "vertical";
            edge.style[key] = value;

            // Keeps the coordinate within the segment bounds
            if (horizontal) {
              pt.x = p0.x;
              pt.y = Math.min(pt.y, Math.max(p0.y, pe.y));
              pt.y = Math.max(pt.y, Math.min(p0.y, pe.y));
            } else {
              pt.y = p0.y;
              pt.x = Math.min(pt.x, Math.max(p0.x, pe.x));
              pt.x = Math.max(pt.x, Math.min(p0.x, pe.x));
            }
          }
        }
        // Computes constraint connection points on vertices and ports
        else if (terminal != null && terminal.cell.geometry.relative) {
          pt = new mxPoint(
            this.getRoutingCenterX(terminal),
            this.getRoutingCenterY(terminal)
          );
        }

        // Snaps point to grid
        /*if (pt != null)
      {
        var tr = this.graph.view.translate;
        var s = this.graph.view.scale;
        
        pt.x = (this.graph.snap(pt.x / s - tr.x) + tr.x) * s;
        pt.y = (this.graph.snap(pt.y / s - tr.y) + tr.y) * s;
      }*/
      }

      edge.setAbsoluteTerminalPoint(pt, source);
    };

    mxConstraintHandler.prototype.createHighlightShape = function () {
      var shape = new mxEllipse(null, "#FF0000", "#FF0000"); // Fill and stroke to red
      shape.dialect = mxConstants.DIALECT_SVG;
      shape.init(this.graph.getView().getOverlayPane());
      shape.node.style.pointerEvents = "none";
      return shape;
    };

    mxConnectionHandler.prototype.getEdgeColor = function (valid) {
      return "#FF0000"; // Red color
    };

    // Sets source terminal point for edge-to-edge connections.
    mxConnectionHandler.prototype.createEdgeState = function (me) {
      var edge = this.graph.createEdge();

      if (this.sourceConstraint != null && this.previous != null) {
        edge.style =
          mxConstants.STYLE_EXIT_X +
          "=" +
          this.sourceConstraint.point.x +
          ";" +
          mxConstants.STYLE_EXIT_Y +
          "=" +
          this.sourceConstraint.point.y +
          ";";
      } else if (this.graph.model.isEdge(me.getCell())) {
        var scale = this.graph.view.scale;
        var tr = this.graph.view.translate;
        var pt = new mxPoint(
          this.graph.snap(me.getGraphX() / scale) - tr.x,
          this.graph.snap(me.getGraphY() / scale) - tr.y
        );
        edge.geometry.setTerminalPoint(pt, true);
      }

      return this.graph.view.createState(edge);
    };

    // Uses right mouse button to create edges on background
    mxConnectionHandler.prototype.isStopEvent = function (me) {
      return me.getState() != null || mxEvent.isRightMouseButton(me.getEvent());
    };

    // Updates target terminal point for edge-to-edge connections.
    //let mxConnectionHandlerUpdateCurrentState = mxConnectionHandler.prototype.updateCurrentState;
    mxConnectionHandler.prototype.updateCurrentState = function (me) {
      //mxConnectionHandlerUpdateCurrentState.apply(this, arguments);

      this.constraintHandler.update(
        me,
        this.first == null,
        false,
        this.first == null || me.isSource(this.marker.highlight.shape)
          ? null
          : point
      );

      if (
        this.constraintHandler.currentFocus != null &&
        this.constraintHandler.currentConstraint != null
      ) {
        // Handles special case where grid is large and connection point is at actual point in which
        // case the outline is not followed as long as we're < gridSize / 2 away from that point
        if (
          this.marker.highlight != null &&
          this.marker.highlight.state != null &&
          this.marker.highlight.state.cell ==
            this.constraintHandler.currentFocus.cell
        ) {
          //if block injected by Rajesh - Apr 03, 2025 - to handle undefined issue while
          // highlight is enabled on dropped vertices.
          if (this.marker.highlight.shape === undefined) {
            this.marker.highlight.repaint();
          }
          // Direct repaint needed if cell already highlighted
          else if (this.marker.highlight.shape.stroke != "transparent") {
            this.marker.highlight.shape.stroke = "transparent";
            this.marker.highlight.repaint();
          }
        } else {
          this.marker.markCell(
            this.constraintHandler.currentFocus.cell,
            "transparent"
          );
        }

        // Updates validation state
        if (this.previous != null) {
          this.error = this.validateConnection(
            this.previous.cell,
            this.constraintHandler.currentFocus.cell
          );

          if (this.error == null) {
            this.currentState = this.constraintHandler.currentFocus;
          }

          if (
            this.error != null ||
            (this.currentState != null &&
              !this.isCellEnabled(this.currentState.cell))
          ) {
            this.constraintHandler.reset();
          }
        }
      } else {
        if (this.graph.isIgnoreTerminalEvent(me.getEvent())) {
          this.marker.reset();
          this.currentState = null;
        } else {
          this.marker.process(me);
          this.currentState = this.marker.getValidState();
        }

        if (
          this.currentState != null &&
          !this.isCellEnabled(this.currentState.cell)
        ) {
          this.constraintHandler.reset();
          this.marker.reset();
          this.currentState = null;
        }

        var outline = this.isOutlineConnectEvent(me);

        if (this.currentState != null && outline) {
          // Handles special case where mouse is on outline away from actual end point
          // in which case the grid is ignored and mouse point is used instead
          if (me.isSource(this.marker.highlight.shape)) {
            var point = new mxPoint(me.getGraphX(), me.getGraphY());
          }

          var constraint = this.graph.getOutlineConstraint(
            point,
            this.currentState,
            me
          );
          this.constraintHandler.setFocus(me, this.currentState, false);
          this.constraintHandler.currentConstraint = constraint;
          this.constraintHandler.currentPoint = point;
        }

        if (this.outlineConnect) {
          if (
            this.marker.highlight != null &&
            this.marker.highlight.shape != null
          ) {
            var s = this.graph.view.scale;

            if (
              this.constraintHandler.currentConstraint != null &&
              this.constraintHandler.currentFocus != null
            ) {
              this.marker.highlight.shape.stroke =
                mxConstants.OUTLINE_HIGHLIGHT_COLOR;
              this.marker.highlight.shape.strokewidth =
                mxConstants.OUTLINE_HIGHLIGHT_STROKEWIDTH / s / s;
              this.marker.highlight.repaint();
            } else if (this.marker.hasValidState()) {
              // Handles special case where actual end point of edge and current mouse point
              // are not equal (due to grid snapping) and there is no hit on shape or highlight
              // but ignores cases where parent is used for non-connectable child cells
              if (
                this.graph.isCellConnectable(me.getCell()) &&
                this.marker.getValidState() != me.getState()
              ) {
                this.marker.highlight.shape.stroke = "transparent";
                this.currentState = null;
              } else {
                this.marker.highlight.shape.stroke =
                  mxConstants.DEFAULT_VALID_COLOR;
              }

              this.marker.highlight.shape.strokewidth =
                mxConstants.HIGHLIGHT_STROKEWIDTH / s / s;
              this.marker.highlight.repaint();
            }
          }
        }
      }

      if (this.edgeState != null) {
        this.edgeState.cell.geometry.setTerminalPoint(null, false);

        if (
          this.shape != null &&
          this.currentState != null &&
          this.currentState.view.graph.model.isEdge(this.currentState.cell)
        ) {
          var scale = this.graph.view.scale;
          var tr = this.graph.view.translate;
          var pt = new mxPoint(
            this.graph.snap(me.getGraphX() / scale) - tr.x,
            this.graph.snap(me.getGraphY() / scale) - tr.y
          );
          this.edgeState.cell.geometry.setTerminalPoint(pt, false);
        }
      }
    };

    // Updates the terminal and control points in the cloned preview.
    mxEdgeSegmentHandler.prototype.clonePreviewState = function (
      point,
      terminal
    ) {
      var clone = mxEdgeHandler.prototype.clonePreviewState.apply(
        this,
        arguments
      );
      clone.cell = clone.cell.clone();

      if (this.isSource || this.isTarget) {
        clone.cell.geometry = clone.cell.geometry.clone();

        // Sets the terminal point of an edge if we're moving one of the endpoints
        if (this.graph.getModel().isEdge(clone.cell)) {
          // TODO: Only set this if the target or source terminal is an edge
          clone.cell.geometry.setTerminalPoint(point, this.isSource);
        } else {
          clone.cell.geometry.setTerminalPoint(null, this.isSource);
        }
      }

      return clone;
    };

    var mxEdgeHandlerConnect = mxEdgeHandler.prototype.connect;
    mxEdgeHandler.prototype.connect = function (
      edge,
      terminal,
      isSource,
      isClone,
      me
    ) {
      var result = null;
      var model = this.graph.getModel();
      var parent = model.getParent(edge);
      model.beginUpdate();
      try {
        result = mxEdgeHandlerConnect.apply(this, arguments);
        var geo = model.getGeometry(result);

        if (geo != null) {
          geo = geo.clone();
          var pt = null;

          if (model.isEdge(terminal)) {
            pt = this.abspoints[this.isSource ? 0 : this.abspoints.length - 1];
            pt.x = pt.x / this.graph.view.scale - this.graph.view.translate.x;
            pt.y = pt.y / this.graph.view.scale - this.graph.view.translate.y;

            var pstate = this.graph
              .getView()
              .getState(this.graph.getModel().getParent(edge));

            if (pstate != null) {
              pt.x -= pstate.origin.x;
              pt.y -= pstate.origin.y;
            }

            pt.x -= this.graph.panDx / this.graph.view.scale;
            pt.y -= this.graph.panDy / this.graph.view.scale;
          }

          geo.setTerminalPoint(pt, isSource);
          model.setGeometry(edge, geo);
        }
      } finally {
        model.endUpdate();
      }

      return result;
    };

    let mxConnectionHandlerCreateMarker =
      mxConnectionHandler.prototype.createMarker;
    mxConnectionHandler.prototype.createMarker = function () {
      var marker = mxConnectionHandlerCreateMarker.apply(this, arguments);

      // Uses complete area of cell for new connections (no hotspot)
      marker.intersects = function (state, evt) {
        return true;
      };

      // Adds in-place highlighting
      let mxCellHighlightHighlight = mxCellHighlight.prototype.highlight;
      marker.highlight.highlight = function (state) {
        if (this.state != state) {
          if (this.state != null) {
            this.state.style = this.lastStyle;

            // Workaround for shape using current stroke width if no strokewidth defined
            this.state.style["strokeWidth"] =
              this.state.style["strokeWidth"] || "1";
            this.state.style["strokeColor"] =
              this.state.style["strokeColor"] || "none";

            if (this.state.shape != null) {
              this.state.view.graph.cellRenderer.configureShape(this.state);
              this.state.shape.redraw();
            }
          }

          if (state != null) {
            this.lastStyle = state.style;
            state.style = mxUtils.clone(state.style);
            state.style["strokeColor"] = "#00ff00";
            state.style["strokeWidth"] = "3";

            if (state.shape != null) {
              state.view.graph.cellRenderer.configureShape(state);
              state.shape.redraw();
            }
          }

          this.state = state;
        }
      };

      return marker;
    };

    let mxEdgeHandlerCreateMarker = mxEdgeHandler.prototype.createMarker;
    mxEdgeHandler.prototype.createMarker = function () {
      var marker = mxEdgeHandlerCreateMarker.apply(this, arguments);

      // Adds in-place highlighting when reconnecting existing edges
      marker.highlight.highlight =
        this.graph.connectionHandler.marker.highlight.highlight;

      return marker;
    };

    let mxGraphGetCellStyle = mxGraph.prototype.getCellStyle;
    mxGraph.prototype.getCellStyle = function (cell) {
      var style = mxGraphGetCellStyle.apply(this, arguments);

      if (style != null && this.model.isEdge(cell)) {
        style = mxUtils.clone(style);

        if (this.model.isEdge(this.model.getTerminal(cell, true))) {
          style["startArrow"] = "oval";
        }

        if (this.model.isEdge(this.model.getTerminal(cell, false))) {
          style["endArrow"] = "oval";
        }
      }

      return style;
    };

    // Register custom shape
    mxCellRenderer.registerShape("nmos4", nmos4Shape);
    mxCellRenderer.registerShape("nmos", nmosShape);
    mxCellRenderer.registerShape("pmos4", pmos4Shape);
    mxCellRenderer.registerShape("pmos", pmosShape);
    mxCellRenderer.registerShape("vdd", vddShape);
    mxCellRenderer.registerShape("vss", vssShape);
    mxCellRenderer.registerShape("input-pin", inputPinShape);
    mxCellRenderer.registerShape("output-pin", outputPinShape);

    // Edges have no connection points
    // mxPolyline.prototype.constraints = null;

    mxEdgeStyle.WireConnector = function (
      state,
      source,
      target,
      hints,
      result
    ) {
      // Creates array of all way- and terminalpoints
      var pts = state.absolutePoints;
      var horizontal = true;
      var hint = null;

      // Gets the initial connection from the source terminal or edge
      if (source != null && state.view.graph.model.isEdge(source.cell)) {
        horizontal = state.style["sourceConstraint"] === "horizontal";
      } else if (source != null) {
        horizontal = source.style["portConstraint"] !== "vertical";

        // Checks the direction of the shape and rotates
        var direction = source.style[mxConstants.STYLE_DIRECTION];

        if (direction === "north" || direction === "south") {
          horizontal = !horizontal;
        }
      }

      // Adds the first point
      // TODO: Should move along connected segment
      var pt = pts[0];

      if (pt == null && source != null) {
        pt = new mxPoint(
          state.view.getRoutingCenterX(source),
          state.view.getRoutingCenterY(source)
        );
      } else if (pt != null) {
        pt = pt.clone();
      }

      var first = pt;

      // Adds the waypoints
      if (hints != null && hints.length > 0) {
        // FIXME: First segment not movable
        /*hint = state.view.transformControlPoint(state, hints[0]);
			mxLog.show();
			mxLog.debug(hints.length,'hints0.y='+hint.y, pt.y)
			
			if (horizontal && Math.floor(hint.y) != Math.floor(pt.y))
			{
				mxLog.show();
				mxLog.debug('add waypoint');

				pt = new mxPoint(pt.x, hint.y);
				result.push(pt);
				pt = pt.clone();
				//horizontal = !horizontal;
			}*/

        for (var i = 0; i < hints.length; i++) {
          horizontal = !horizontal;
          hint = state.view.transformControlPoint(state, hints[i]);

          if (horizontal) {
            if (pt.y != hint.y) {
              pt.y = hint.y;
              result.push(pt.clone());
            }
          } else if (pt.x != hint.x) {
            pt.x = hint.x;
            result.push(pt.clone());
          }
        }
      } else {
        hint = pt;
      }

      // Adds the last point
      pt = pts[pts.length - 1];

      // TODO: Should move along connected segment
      if (pt == null && target != null) {
        pt = new mxPoint(
          state.view.getRoutingCenterX(target),
          state.view.getRoutingCenterY(target)
        );
      }

      if (horizontal) {
        if (pt.y != hint.y && first.x != pt.x) {
          result.push(new mxPoint(pt.x, hint.y));
        }
      } else if (pt.x != hint.x && first.y != pt.y) {
        result.push(new mxPoint(hint.x, pt.y));
      }
    };

    mxStyleRegistry.putValue("wireEdgeStyle", mxEdgeStyle.WireConnector);

    // This connector needs an mxEdgeSegmentHandler
    let mxGraphCreateHandler = mxGraph.prototype.createHandler;
    mxGraph.prototype.createHandler = function (state) {
      var result = null;

      if (state != null) {
        if (this.model.isEdge(state.cell)) {
          var style = this.view.getEdgeStyle(state);

          if (style == mxEdgeStyle.WireConnector) {
            return new mxEdgeSegmentHandler(state);
          }
        }
      }

      return mxGraphCreateHandler.apply(this, arguments);
    };

    /**
     * Function: getPreviewTerminalState
     *
     * Updates the given preview state taking into account the state of the constraint handler.
     */
    mxEdgeHandler.prototype.getPreviewTerminalState = function (me) {
      this.constraintHandler.update(
        me,
        this.isSource,
        true,
        me.isSource(this.marker.highlight.shape) ? null : this.currentPoint
      );

      if (
        this.constraintHandler.currentFocus != null &&
        this.constraintHandler.currentConstraint != null
      ) {
        // Handles special case where grid is large and connection point is at actual point in which
        // case the outline is not followed as long as we're < gridSize / 2 away from that point
        if (
          this.marker.highlight != null &&
          this.marker.highlight.state != null &&
          this.marker.highlight.state.cell ==
            this.constraintHandler.currentFocus.cell
        ) {
          // // Direct repaint needed if cell already highlighted
          // if (this.marker.highlight.shape.stroke != 'transparent')
          // {
          // 	this.marker.highlight.shape.stroke = 'transparent';
          // 	this.marker.highlight.repaint();
          // }

          //if block injected by Rajesh - Apr 03, 2025 - to handle undefined issue while
          // highlight is enabled on dropped vertices.
          if (this.marker.highlight.shape === undefined) {
            this.marker.highlight.repaint();
          }
          // Direct repaint needed if cell already highlighted
          else if (this.marker.highlight.shape.stroke != "transparent") {
            this.marker.highlight.shape.stroke = "transparent";
            this.marker.highlight.repaint();
          }
        } else {
          this.marker.markCell(
            this.constraintHandler.currentFocus.cell,
            "transparent"
          );
        }

        var model = this.graph.getModel();
        var other = this.graph.view.getTerminalPort(
          this.state,
          this.graph.view.getState(
            model.getTerminal(this.state.cell, !this.isSource)
          ),
          !this.isSource
        );
        var otherCell = other != null ? other.cell : null;
        var source = this.isSource
          ? this.constraintHandler.currentFocus.cell
          : otherCell;
        var target = this.isSource
          ? otherCell
          : this.constraintHandler.currentFocus.cell;

        // Updates the error message of the handler
        this.error = this.validateConnection(source, target);
        var result = null;

        if (this.error == null) {
          result = this.constraintHandler.currentFocus;
        }

        if (
          this.error != null ||
          (result != null && !this.isCellEnabled(result.cell))
        ) {
          this.constraintHandler.reset();
        }

        return result;
      } else if (!this.graph.isIgnoreTerminalEvent(me.getEvent())) {
        this.marker.process(me);
        var state = this.marker.getValidState();

        if (state != null && !this.isCellEnabled(state.cell)) {
          this.constraintHandler.reset();
          this.marker.reset();
        }

        return this.marker.getValidState();
      } else {
        this.marker.reset();

        return null;
      }
    };
  }

  function getCellsWithEdges(graph) {
    const selected = graph.getSelectionCells();
    const edges = graph.getAllEdges(selected);
    const all = graph.model.getTopmostCells(selected.concat(edges));
    return all;
  }

  function onExportClick() {


    window["mxGraphModel"] = mxGraphModel;
    window["mxGeometry"] = mxGeometry;
    window["mxPoint"] = mxPoint;
    var model = graph.getModel();
    var encoder = new mxCodec();
    var node = encoder.encode(model);
    var xml = mxUtils.getXml(node);

    // var temp = mxUtils.getXml(encoder);
    console.log("temp", xml)

    var escapedXml = xml.replace(/"/g, '\\"');

    setGXml(escapedXml);
    setOpenDialog(true);
  }

  function loadXmlOnGraphForEdit(graph, xmlData) {
    window["mxGraphModel"] = mxGraphModel;
    window["mxGeometry"] = mxGeometry;
    window["mxPoint"] = mxPoint;
    var req = mxUtils.parseXml(xmlData);
    var root = req.documentElement;
    var dec = new mxCodec(root.ownerDocument);
    dec.decode(root, graph.getModel());
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const onResetClick = () => {
    setOpenResetDialog(true);
  };

  const handleCancelReset = () => {
    setOpenResetDialog(false);
  };

  const handleConfirmReset = () => {
    if (graph) {
      graph.getModel().beginUpdate();
      try {
        graph.removeCells(graph.getChildVertices(graph.getDefaultParent()));
      } finally {
        graph.getModel().endUpdate();
      }
    }
    window.removeEventListener("beforeunload", handleBeforeUnload);
    window.location.href = "/practice";
    setOpenResetDialog(false);
  };

  const [openAddInstance, setOpenAddInstance] = useState(false);
  const [openAddPin, setOpenAddPin] = useState(false);

  const handleOpenAddInstance = () => {
    setOpenAddInstance(true);
    handleMenuClose();
  };

   const handleOpenNewCell = () => {
    setNewCellOpen(true)
    handleMenuClose();
  };

// const handleInstanceClick = (shapeType, iconPath, label) => {
//   selectedShapeTypeRef.current = shapeType;
//   selectedIconPathRef.current = iconPath;
//   const style = `shape=${shapeType}; labelPosition=right;align=right`;
//   const vertex = new mxCell("", new mxGeometry(0, 0, 60, 90), style);
//   vertex.setVertex(true);

//   insertModeRef.current = true;
//   insertCellRef.current = vertex;

//   // Create a wrapper for ghost image and label
//   const previewWrapper = document.createElement("div");
//   previewWrapper.style.position = "absolute";
//   previewWrapper.style.pointerEvents = "none";
//   previewWrapper.style.opacity = "0.8";
//   previewWrapper.style.zIndex = "9999";

//   // Create a container for image with relative position
//   const imageWrapper = document.createElement("div");
//   imageWrapper.style.position = "relative";
//   imageWrapper.style.width = "60px";
//   imageWrapper.style.height = "90px";

//   // Ghost image
//   const ghost = document.createElement("img");
//   ghost.src = iconPath;
//   ghost.style.width = "100%";
//   ghost.style.height = "100%";
//   ghost.style.display = "block";
//   imageWrapper.appendChild(ghost);

//   // Conditionally add label on top-left of image
//   if (!!label) {
//     const labelElement = document.createElement("span");
//     labelElement.textContent = label;
//     labelElement.style.position = "absolute";
//     labelElement.style.top = "2px";
//     labelElement.style.left = "2px";
//     labelElement.style.fontSize = "12px";
//     labelElement.style.color = "#000";
//     labelElement.style.backgroundColor = "white";
//     labelElement.style.padding = "2px 4px";
//     labelElement.style.borderRadius = "4px";
//     labelElement.style.boxShadow = "0 1px 4px rgba(0,0,0,0.2)";
//     imageWrapper.appendChild(labelElement);
//   }

//   // Append everything
//   previewWrapper.appendChild(imageWrapper);

//   const container = containerRef.current;
//   if (container) {
//     container.appendChild(previewWrapper);
//     previewRef.current = previewWrapper;
//   }
//   previewRef.current = ghost;
//   const name = `i${instanceCounterRef.current}`;
//   setNextInstanceName(name); 
// };

const handleInstanceClick = (shapeType, iconPath) => {
  selectedShapeTypeRef.current = shapeType;
  selectedIconPathRef.current = iconPath;
  const style = `shape=${shapeType}; labelPosition=right;align=right`;
  const vertex = new mxCell("", new mxGeometry(0, 0, 60, 90), style);
  vertex.setVertex(true);
  // startDragAndDrop(graph, vertex, iconPath);
   insertModeRef.current = true;
  insertCellRef.current = vertex;
  const ghost = document.createElement("img");
  ghost.src = iconPath;
  ghost.style.position = "absolute";
  ghost.style.width = "60px";
  ghost.style.height = "90px";
  ghost.style.pointerEvents = "none";
  ghost.style.opacity = "0.6";
  ghost.style.zIndex = "9999";

  // document.body.appendChild(ghost);
  const container = containerRef.current;
  if (container) {
    container.appendChild(ghost);
    previewRef.current = ghost;
  }
  previewRef.current = ghost;
  const name = `i${instanceCounterRef.current}`;
  setNextInstanceName(name); 
};

const handleCellSelect = (shapeType, imagePath, label) => {
  handleInstanceClick(shapeType, imagePath, label); // existing logic for preview and placement
};

const handleCloseTab = (indexToRemove) => {
  const newTabs = tabs.filter((_, index) => index !== indexToRemove);

  let newSelectedTab = selectedTab;
  
  if (newTabs.length === 0) {
    // No tabs left
    newSelectedTab = -1;
  } else if (selectedTab === indexToRemove) {
    // If we're removing the currently selected tab
    if (indexToRemove >= newTabs.length) {
      // If we're removing the last tab, select the new last tab
      newSelectedTab = newTabs.length - 1;
    } else {
      // Otherwise, stay at the same position (which will now show the next tab)
      newSelectedTab = indexToRemove;
    }
  } else if (selectedTab > indexToRemove) {
    // If we're removing a tab before the selected one, decrement the index
    newSelectedTab = selectedTab - 1;
  }
  
  setTabs(newTabs);
  setSelectedTab(newSelectedTab);
};

const handleOpenAddPin = () => {
  setOpenAddPin(true);
  handleMenuClose();
};

  return (
    <>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        {/* <HeaderBar /> */}
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ color: "#fff", pl: 1, backgroundColor: "#fff" }}
        >
          <Grid
            item
            sx={{
              ml: "auto",
              mr: 1,
              display: "flex",
              justifyContent: "flex-end",
            }}>

            <Button
              id="demo-customized-button"
              aria-controls={open ? 'demo-customized-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              variant="contained"
              disableElevation
              onClick={handleMenuClick}
              endIcon={<KeyboardArrowDownIcon />}
              sx={{ mr: 1 }}
              className="customButtonStyle"
            > Create </Button>
            <StyledMenu
              id="demo-customized-menu"
              MenuListProps={{ 'aria-labelledby': 'demo-customized-button',}}
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleMenuClose} > 
              <MenuItem onClick={handleOpenNewCell} disableRipple> New Cell </MenuItem>
              <MenuItem onClick={handleOpenAddInstance} disableRipple> Add Instance </MenuItem> 
              <MenuItem onClick={handleOpenAddPin} disableRipple> Add Pin </MenuItem> 
            </StyledMenu>
            {/* <Button variant="contained" className="customButtonStyle" style={{marginRight: "10px"}} 
            // onClick={handleOpenAddInstance}
            onClick={() => handleInstanceClick('nmos4', '/editors/images/toolbox/nmos.svg')}
             >Add Instance</Button>
            <Button variant="contained" className="customButtonStyle" style={{marginRight: "10px"}} onClick={()=> setNewCellOpen(true)}> New Cell</Button> */}
            <Button
              variant="contained"
              onClick={onExportClick}
              disabled={isDiagramEmpty}
              style={{
                backgroundColor: "#808080",
                textTransform: "none",
                marginRight: "10px",
              }}
              startIcon={<SaveIcon />}
            >
              {isEditMode ? "Update" : "Save"}
            </Button>
            <Button
              variant="contained"
              onClick={onResetClick}
              style={{
                backgroundColor: "#808080",
                textTransform: "none",
                // marginRight: "20px",
              }}
              startIcon={<RestartAltIcon />}
            >
              Reset
            </Button>
          </Grid>

          {/* Right Grid - Controls */}
          <Grid item>
            <GraphToolbar
              graph={graphRef.current}
              containerRef={containerRef.current}
              theme={theme}
              commonRef={commonRef.current}
              isDarkMode={isDarkMode}
              toggleMode={toggleMode}
            />
          </Grid>
        </Grid>
        {/* tabs */}
        <Box sx={{ height: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column' }}>
          <Tabs value={selectedTab} onChange={handleTabChange} className="custom-tabs"
            TabIndicatorProps={{
              style: { display: 'none'}, // Hide the default indicator
            }}>
            {tabs.map((label, index) => (
              // <Tab key={index} label={label} />
              <Tab
                key={index}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {label}
                    {selectedTab === index && (
                      <CloseIcon
                        fontSize="small"
                        sx={{ ml: 1, cursor: 'pointer' }}
                        onClick={(event) => {
                          event.stopPropagation(); // prevent tab switch
                          handleCloseTab(index);
                        }}
                      />
                    )}
                  </Box>
                }
              />
            ))}
          </Tabs>

          {/* Content of selected tab can go here */}
          {tabs.length > 0 && (
            <ThemeProvider theme={localTheme}>
            <CssBaseline />
            <Box sx={{ flexGrow: 1, minHeight: 0, position: "relative" }}>
              <Grid
                container
                sx={{ display: "flex", flexWrap: "nowrap", height: "100%"  }}
              >
                <Grid
                  item
                  id="graphContainer"
                  ref={containerRef}
                  sx={{
                    backgroundPosition: "-1px 0px",
                    cursor: "default",
                    overflow: "auto",
                    flexGrow: 1,
                    position: "relative"
                  }}
                >
                </Grid>
              
              </Grid>
              <Dialog
                open={openResetDialog}
                onClose={handleCancelReset}
                PaperProps={{
                  className: "dialog",
                }}
              >
                <DialogTitle className="dialogTitle">
                  Confirm Reset
                  <IconButton
                    aria-label="close"
                    onClick={handleCancelReset}
                    className="dialogCloseIcon"
                  >
                    <CancelIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Alert severity="warning" className="confirmDialogMsg">
                    {" "}
                    All the changes made in the current project will be lost.
                    You are about to create a new project. Do you wish to
                    continue?{" "}
                  </Alert>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    onClick={handleCancelReset}
                    style={{
                      // backgroundColor: "#7F141A",
                      textTransform: "none",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleConfirmReset}
                    style={{
                      // backgroundColor: "#7F141A",
                      textTransform: "none",
                    }}
                  >
                    OK
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
            </ThemeProvider>
          )}
        </Box>
      </Box>
      <AddInstanceDialog open={openAddInstance} onClose={() => setOpenAddInstance(false)} onCellSelect={handleCellSelect} instanceName={nextInstanceName} />
      <NewCellDialog open={newCellopen} onClose={() => setNewCellOpen(false)} onCreate={handleCreateCell}/>
      <AddPinDialog open={openAddPin} onClose={() => setOpenAddPin(false)} onCellSelect={handleCellSelect}/>
    </>
  );
};

Diagram.propTypes = {};

Diagram.defaultProps = {};

export default Diagram;
